import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { $http } from "../../instance/axios.instance"

function header() {
    const [facebook, setFacebook] = useState("");
    const [twitter, setTwitter] = useState("");
    const [instagram, setIntsagram] = useState("");
    const [youtube, setYoutube] = useState("");
    const [contact_phone, setPhone] = useState("");
    const [contact_email, setEmail] = useState("");

    useEffect(() => {
        async function fetchData() {
            try {
                const [footer] = await Promise.all([
                    $http.get("footer-content"),
                ]);
                if (footer) {
                    setFacebook(footer.data.data?.attributes?.facebook);
                    setTwitter(footer.data.data?.attributes?.twitter);
                    setIntsagram(footer.data.data?.attributes?.instagram);
                    setYoutube(footer.data.data?.attributes?.youtube);
                    setPhone(footer.data.data?.attributes?.contact_phone);
                    setEmail(footer.data.data?.attributes?.contact_email);
                }

            }
            catch (e) {
                console.log(e)
            }
        };
        fetchData();
    }, []);
    return (
        <>
            <div className="top-header pt-2 pb-2">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-sm-6">
                            <ul className="left-info">
                                <li>
                                    <a href={`${'mailto:'+contact_email}`}>
                                        <i className="las la-envelope"></i>
                                        {contact_email}
                                    </a>
                                </li>
                                <li>
                                    <a href={`${'tel:'+contact_phone}`}>
                                        <i className="las la-phone"></i>
                                        {contact_phone}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <ul className="right-info">
                                <li>
                                    <a href={`${facebook}`} target="_blank">
                                        <i className="lab la-facebook-f"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={`${twitter}`} target="_blank">
                                        <i className="lab la-twitter"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={`${instagram}`} target="_blank">
                                        <i className="lab la-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={`${youtube}`} target="_blank">
                                        <i className="lab la-youtube"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default header